/* eslint-disable jsx-a11y/label-has-associated-control */
import { Field, useField } from "formik";
import React from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import { EnableInputOptions } from "../../models/pitchUxModels";
import * as commonStyles from "../commonStyles/commonStyles.module.css";
import { FieldErrorMessage } from "../FieldErrorMessage";
import { FieldHeader, FieldHeaderProps } from "../FieldHeader";
import * as styles from "./RadioOptionsField.module.css";

export type RadioOption = Readonly<{
  value: string | number;
  label: string;
}>;

export type RadioOptionsFieldProps = Readonly<{
  options: RadioOption[];
  name: string;
  listAsColumn?: boolean;
  isSaving?: boolean;
  setChildInputForm?: React.Dispatch<React.SetStateAction<boolean | undefined>>;
}> &
  FieldHeaderProps;

export const RadioOptionsField = (props: RadioOptionsFieldProps) => {
  const { name, options, listAsColumn, isSaving, setChildInputForm } = props;
  const [field] = useField(props);

  const check = (value: string) => {
    if (setChildInputForm) {
      if (value === EnableInputOptions.No) {
        setChildInputForm(false);
      } else {
        setChildInputForm(true);
      }
    }
  };

  return (
    <Row className={commonStyles.container}>
      <Column>
        <FieldHeader {...props} />
        <div role="group" aria-labelledby="radio-options-group">
          <div className={listAsColumn ? undefined : styles.optionsGroups}>
            {options.map(option => (
              <label
                key={`radio-option-${option.value}`}
                className={listAsColumn ? styles.optionAsColumn : styles.option}
              >
                <Field
                  type="radio"
                  name={name}
                  value={option.value.toString()}
                  data-testid={name}
                  disabled={isSaving}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    field.onChange(event);
                    check(event.target.value);
                  }}
                />
                {option.label}
              </label>
            ))}
          </div>
        </div>
        <FieldErrorMessage fieldName={field.name} />
      </Column>
    </Row>
  );
};
